<form [formGroup]="formGroup">

<aims-common-table
    id="cart-table"
    [dataSource]="cart.cartItems"
    [header]="cartItemsHeader"
    [permissions]="cartItemsPermissions"
    [hidePageSize]="true"
    pageSize="10"
    (rowDeleted)="handleRowDelete($event)"
    (rowUpdated)="handleRowUpdate($event)"
    (rowEdit)="handleRowEdit($event)"
    [stickyHeader]="true">

      <ng-template aimsCommonTableDynamicToolbar>
        <aims-common-button aria-label="Update" (click)="updateInstock()">
          <mat-icon>refresh</mat-icon>
          Refresh Instock
        </aims-common-button>
      </ng-template>

      <aims-common-table-dynamic-row id="quantity">
        <ng-template viewMode let-element style="width:70px">
           <span [style.color]="(element.quantity > element.instock) ? 'red': 'black'">{{ element.quantity }}</span>
        </ng-template>

        <ng-template editMode let-element let-dynamicControl="dynamicControl" let-formGroup="formGroup">
          <mat-form-field appearance="fill" class="editable-text-field form-component" >
              <input matInput
                  type="number"
                  name="Quantity"
                  id="quantity"
                  [formControl]="dynamicControl"
                  [max]="element.instock"
                  min="0"
              />
              <mat-error>0 &lt;= quantity &lt; instock</mat-error>
          </mat-form-field>
        </ng-template>
      </aims-common-table-dynamic-row>

      <aims-common-table-dynamic-row id="instock">
        <ng-template viewMode let-element style="width:70px">
           <span [style.color]="(element.quantity > element.instock) ? 'red': 'black'">{{ element.instock }}</span>
        </ng-template>
      </aims-common-table-dynamic-row>
</aims-common-table>

<div style="margin-top: 20px;">

  <div class="dialog-row">
    <div class="dialog-column">
      <mat-form-field>
        <mat-label>Attach To:</mat-label>
        <mat-select formControlName="attachedToType" class="fullWidth" name="AttachedToType"
            (selectionChange)="attachedToChange($event.value)"  >
          <mat-option *ngFor="let t of inventoryAttachedToTypes" [value]="t.inventoryAttachedToTypeId">
            {{ t.attachedToType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="dialog-column" >

      <div *ngIf="woOnly">
        <mat-icon color="warn" class="material-icons">arrow_back</mat-icon>
        <span class="message warningmessage">Work Order required by one or more item(s) in cart</span>
      </div>
    </div>
    </div>
  <div class="dialog-row">
    <div class="dialog-column">
      <div *ngIf="woShow">

        <mat-radio-group class="" formControlName="woAction" labelPosition="before" (change)="woActionChange($event)" *ngIf="inventoryTenantConfig.allowInventoryToCreateWorkOrders">
          <mat-radio-button class="" value="lookup">Lookup</mat-radio-button>
          <mat-radio-button class="" value="create">Create</mat-radio-button>
        </mat-radio-group>

        <div *ngIf="showWoLookup">
          <label>Lookup Work Order</label>
          <aims-lookup
            name="Work Order"
            formControlName="workOrderId"
            class="fullWidth"
            [gridText]="'Select a Work Order'"
            [values]="workOrderFilteredValues | async"
            [idPropertyName]="'workOrderId'"
            [displayPropertyName]="'workOrderNumber'"
            [columnsInGrid]="workOrderLookupColumns" >
          </aims-lookup>
        </div>

        <div *ngIf="showWoCreate">
          <mat-form-field appearance="fill" class="fullWidth">
            <mat-label>Work Order Number</mat-label>
            <input
                matInput
                type="text"
                name="workOrderNumber"
                formControlName="workOrderNumber"
                [max]=50
            />
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="assetShow">
        <aims-lookup name="Asset"
          formControlName="equipmentId"
          class="fullWidth"
          [values]="equipmentList | async"
          [gridText]="'Select an Asset'"
          [displayPropertyName]="'equipmentIdOld'"
          [idPropertyName]="'equipmentId'"
          [columnsInGrid]="equipmentLookupColumns" >
        </aims-lookup>
      </div>

      <div *ngIf="scheduleShow">
        <aims-lookup name="ScheduleItemId"
          formControlName="scheduleItemId"
          class="fullWidth"
          [gridText]="'Select a Schedule Item'"
          [values]="scheduleItems | async"
          [idPropertyName]="'scheduleItemId'"
          [displayPropertyName]="'siDescription'"
          [columnsInGrid]="scheduleItemLookupColumns" >
        </aims-lookup>
      </div>

      <div *ngIf="travelerShow">
        <aims-lookup name="TravelerId"
          formControlName="travelerId"
          class="fullWidth"
          [gridText]="'Select a Traveler'"
          [values]="travelers | async"
          [idPropertyName]="'travelerId'"
          [displayPropertyName]="'description'"
          [columnsInGrid]="travelerLookupColumns" >
        </aims-lookup>
      </div>

      <div *ngIf="manualShow">
        <mat-form-field appearance="fill" class="fullWidth" >
          <textarea matInput
            formControlName="manualNote"
            name="Note"
            placeholder="Note"
            maxlength="240"
            >
          </textarea>
        </mat-form-field>
      </div>
    </div>

  </div>

  <div class="dialog-row" style="margin-top: 20px;">
    <div class="dialog-column">
    <label>Pulled For</label>
    <aims-lookup
          formControlName="pulledForId"
                  name="Employee"
                  [gridText]="'Select a User'"
                  [values]="employees"
                  [idPropertyName]="'employeeId'"
                  [displayPropertyName]="'fullName'"
                  [columnsInGrid]="userLookupColumns"
                  >
      </aims-lookup>
    </div>
  </div>

</div>
</form>

<aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
